module.exports = __webpack_public_path__ + "media/images/icons/flat-color-square-youtube-453d8ba8bdf1ae7385cd8a14734b4cf8.png";